module.exports = __webpack_public_path__ + "img/0.948f7915.png";